export class BaseObject {
    createdDate: Date;
    createdUserDisplayName: string;
    createdUserId: number;

    updatedDate: Date;
    updatedUserDisplayName: string;
    updatedUserId: number;
}